import React, { ReactNode } from 'react'
import { CustomIconName } from '.'

export const glyphs: Record<CustomIconName, ReactNode> = {
  // Animated "breathing" green blob used as the Homepal AI avatar. Carries its
  // own fill colour and SMIL/CSS animation (it is not a currentColor glyph).
  AiBlob: (
    <>
      <style>
        {`
        .ai-blob {
          transform-box: fill-box;
          transform-origin: center;
          will-change: transform;
        }
        .ai-blob--back { animation: ai-blob-breathe-back 7s ease-in-out infinite; }
        .ai-blob--front { animation: ai-blob-breathe-front 5.5s ease-in-out infinite; }
        @keyframes ai-blob-breathe-back {
          0% { transform: scale(1) rotate(0deg); }
          50% { transform: scale(1.06) rotate(4deg); }
          100% { transform: scale(1) rotate(0deg); }
        }
        @keyframes ai-blob-breathe-front {
          0% { transform: scale(1) rotate(0deg); }
          50% { transform: scale(1.04) rotate(-3deg); }
          100% { transform: scale(1) rotate(0deg); }
        }
        @media (prefers-reduced-motion: reduce) {
          .ai-blob { animation: none; }
        }
      `}
      </style>
      <g className="ai-blob ai-blob--back">
        <path
          opacity="0.5"
          fill="#22C55E"
          d="M12 1.8C17 2 22.2 5 22.2 12C22.2 18 17.6 22.2 12 22.2C6.2 22.2 1.8 17.6 1.8 12C1.8 6 7 1.6 12 1.8Z"
        >
          <animate
            attributeName="d"
            dur="8s"
            repeatCount="indefinite"
            calcMode="spline"
            keyTimes="0;0.33;0.66;1"
            keySplines="0.4 0 0.6 1;0.4 0 0.6 1;0.4 0 0.6 1"
            values="M12 1.8C17 2 22.2 5 22.2 12C22.2 18 17.6 22.2 12 22.2C6.2 22.2 1.8 17.6 1.8 12C1.8 6 7 1.6 12 1.8Z;
                    M11.6 2C16.6 1.8 21.8 5.6 22 11.6C22.2 18 16.8 22.4 11.4 22C5.8 21.6 1.6 17 2 11.4C2.4 5.4 7 2.2 11.6 2Z;
                    M12.4 2C17.6 2.4 22 6 21.8 12.4C21.6 18.4 17 22 11.6 21.8C6 21.6 2 16.6 2.2 11C2.4 5.4 7.4 1.6 12.4 2Z;
                    M12 1.8C17 2 22.2 5 22.2 12C22.2 18 17.6 22.2 12 22.2C6.2 22.2 1.8 17.6 1.8 12C1.8 6 7 1.6 12 1.8Z"
          />
        </path>
      </g>
      <g className="ai-blob ai-blob--front">
        <path
          fill="#22C55E"
          d="M12 2.4C16.5 2.4 21.6 5.4 21.6 12C21.6 17.7 17.4 21.6 12 21.6C6.6 21.6 2.4 17.4 2.4 12C2.4 6.6 7.5 2.4 12 2.4Z"
        >
          <animate
            attributeName="d"
            dur="6.5s"
            repeatCount="indefinite"
            calcMode="spline"
            keyTimes="0;0.33;0.66;1"
            keySplines="0.4 0 0.6 1;0.4 0 0.6 1;0.4 0 0.6 1"
            values="M12 2.4C16.5 2.4 21.6 5.4 21.6 12C21.6 17.7 17.4 21.6 12 21.6C6.6 21.6 2.4 17.4 2.4 12C2.4 6.6 7.5 2.4 12 2.4Z;
                    M12.4 2.6C17 3 21.4 6.2 21.2 12.2C21 18 16.8 21.8 11.6 21.4C6.4 21 2.6 16.8 2.8 11.4C3 6 7.8 2.2 12.4 2.6Z;
                    M11.6 2.2C16.8 2 21.8 6.6 21.4 12.4C21 18.2 17.2 21 11.4 21.6C6 22.2 2.2 16.6 2.6 11C3 5.6 6.8 2.4 11.6 2.2Z;
                    M12 2.4C16.5 2.4 21.6 5.4 21.6 12C21.6 17.7 17.4 21.6 12 21.6C6.6 21.6 2.4 17.4 2.4 12C2.4 6.6 7.5 2.4 12 2.4Z"
          />
        </path>
      </g>
    </>
  ),
  LeftSidebar: (
    <>
      <path
        d="M21 6C21 5.44772 20.5523 5 20 5H4C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V6ZM23 18C23 19.6569 21.6569 21 20 21H4C2.34315 21 1 19.6569 1 18V6C1 4.34315 2.34315 3 4 3H20C21.6569 3 23 4.34315 23 6V18Z"
        fill="currentColor"
      />
      <path
        d="M5 8C5 7.44772 5.44772 7 6 7H8C8.55228 7 9 7.44772 9 8V16C9 16.5523 8.55228 17 8 17H6C5.44772 17 5 16.5523 5 16V8Z"
        fill="currentColor"
      />
    </>
  ),
  MobileBottomDrawer: (
    <>
      <path
        d="M18 21C18.5523 21 19 20.5523 19 20L19 4C19 3.44772 18.5523 3 18 3L6 3C5.44772 3 5 3.44771 5 4L5 20C5 20.5523 5.44771 21 6 21L18 21ZM6 23C4.34314 23 3 21.6569 3 20L3 4C3 2.34315 4.34315 1 6 1L18 1C19.6569 1 21 2.34315 21 4L21 20C21 21.6569 19.6569 23 18 23L6 23Z"
        fill="currentColor"
      />
      <path
        d="M16 15C16.5523 15 17 15.4477 17 16L17 18C17 18.5523 16.5523 19 16 19L8 19C7.44772 19 7 18.5523 7 18L7 16C7 15.4477 7.44772 15 8 15L16 15Z"
        fill="currentColor"
      />
    </>
  ),
  RightSidebar: (
    <>
      <path
        d="M21 6C21 5.44772 20.5523 5 20 5H4C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V6ZM23 18C23 19.6569 21.6569 21 20 21H4C2.34315 21 1 19.6569 1 18V6C1 4.34315 2.34315 3 4 3H20C21.6569 3 23 4.34315 23 6V18Z"
        fill="currentColor"
      />
      <path
        d="M15 8C15 7.44772 15.4477 7 16 7H18C18.5523 7 19 7.44772 19 8V16C19 16.5523 18.5523 17 18 17H16C15.4477 17 15 16.5523 15 16V8Z"
        fill="currentColor"
      />
    </>
  )
}
